import React, { Component, Fragment } from "react";
import { Route, Routes } from "react-router-dom";
import RoutePaths from "utils/RoutePaths";
import ListUsers from "./ListUsers";

// Helper to get relative path from full path
const getRelativePath = (fullPath) => fullPath.replace(/^\/admin\/unverifiedUsers\/?/, '') || '/';

export default class UnverifiedUsers extends Component {
  render() {
    return (
      <Fragment>
        <Routes>
          <Route path={getRelativePath(RoutePaths.unverifiedUsers)} element={<ListUsers />} />
        </Routes>
      </Fragment>
    );
  }
}